<template>
  <div class='StepTwo'>
    <InitTitle 
    text="Vamos criar sua estrutura online"
    desc="Preencha os dados do seu negócio."
    />
    <div class="cont">
      <InitInput
      label="Nome do negócio"
      width="48.5%"
      :value="payload.nome_empresa"
      @returnValue="newValue => {
        $emit('updateProp', { key: 'nome_empresa', value: newValue })
        $emit('updateProp', { key: 'subdominio', value: formatarTexto(newValue) })
      }"
      :error="verify.nome_empresa.$invalid"
      />
      <InitInput
      type="select"
      :options="models"
      label="Categoria"
      width="48.5%"
      @returnValue="newValue => $emit('updateProp', { key: 'modelo', value: newValue })"
      :error="verify.modelo.$invalid"
      />
    </div>
    <div class="cont">
      <InitInput
      label="Link que deseja utilizar"
      placeholder="Nome do seu negócio"
      textInput=".enobairro.com"
      :value="payload.subdominio"
      @returnValue="newValue => $emit('updateProp', { key: 'subdominio', value: formatarTexto(newValue) })"
      :error="verify.subdominio.$invalid"
      :errorMsg="verify.subdominio.formato.$invalid ? verify.subdominio.formato.$message : verify.subdominio.has.$invalid ? verify.subdominio.has.$message : ''"
      />
    </div>
    <div class="cont">
      <InitInput
      label="Telefone / WhatsApp"
      width="48.5%"
      :value="payload.telefone"
      :Mask="['(##) #####-####']"
      @returnValue="newValue => $emit('updateProp', { key: 'telefone', value: newValue })"
      :error="verify.telefone.$invalid"
      />
      <InitInput
      label="CEP"
      width="48.5%"
      :value="payload.cep"
      :Mask="['#####-###']"
      @returnValue="newValue => getEndereco(newValue)"
      :error="verify.cep.$invalid"
      />
    </div>
    <div class="cont">
      <InitInput
      label="Rua"
      width="77%"
      :value="payload.rua"
      @returnValue="newValue => $emit('updateProp', { key: 'rua', value: newValue })"
      :error="verify.rua.$invalid"
      />
      <InitInput
      label="Número"
      width="20%"
      :value="payload.numero"
      :Mask="['##############']"
      @returnValue="newValue => $emit('updateProp', { key: 'numero', value: newValue })"
      :error="verify.numero.$invalid"
      />
    </div>
    <div class="cont">
      <InitInput
      label="Complemento"
      :required="false"
      width="48.5%"
      :value="payload.complemento"
      @returnValue="newValue => $emit('updateProp', { key: 'complemento', value: newValue })"
      />
      <InitInput
      label="Bairro"
      width="48.5%"
      :value="payload.bairro"
      @returnValue="newValue => $emit('updateProp', { key: 'bairro', value: newValue })"
      :error="verify.bairro.$invalid"
      />
    </div>
    <div class="cont">
      <InitInput
      label="Cidade"
      width="77%"
      :value="payload.cidade"
      @returnValue="newValue => $emit('updateProp', { key: 'cidade', value: newValue })"
      :error="verify.cidade.$invalid"
      />
      <InitInput
      label="UF"
      width="20%"
      :value="payload.uf"
      :Mask="['AA']"
      @returnValue="newValue => $emit('updateProp', { key: 'uf', value: newValue })"
      :error="verify.uf.$invalid"
      />
    </div>
    <div class="cont-next">
      <!-- <button @click="$emit('changeView', 'StepOne')">Voltar</button> -->
      <button @click="next">Próximo</button>
    </div>
  </div>
</template>

<script>
import InitTitle from './InitTitle'
import InitInput from './InitInput'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers, minLength } from '@vuelidate/validators'
import { mapActions } from 'vuex'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'StepTwo',
  components: { InitTitle, InitInput },
  props: ['payload'],
  data () {
    return {
      models: [
        { value: '', name: '' },
        { value: 'Modelo 01', name: 'Loja Online' },
        { value: 'Modelo 03', name: 'Imóveis' }
      ],
      verify: {
        nome_empresa: { $invalid: false },
        subdominio: { $invalid: false, formato: { $invalid: false, $message: '' }, has: { $invalid: false, $message: '' } },
        modelo: { $invalid: false },
        telefone: { $invalid: false },
        cep: { $invalid: false },
        rua: { $invalid: false },
        numero: { $invalid: false },
        bairro: { $invalid: false },
        cidade: { $invalid: false },
        uf: { $invalid: false }
      }
    }
  },
  computed: {
    nome_empresa () {
      return this.payload.nome_empresa
    },
    subdominio () {
      return this.payload.subdominio
    },
    modelo () {
      return this.payload.modelo
    },
    telefone () {
      return this.payload.telefone
    },
    cep () {
      return this.payload.cep
    },
    rua () {
      return this.payload.rua
    },
    numero () {
      return this.payload.numero
    },
    bairro () {
      return this.payload.bairro
    },
    cidade () {
      return this.payload.cidade
    },
    uf () {
      return this.payload.uf
    }
  },
  validations () {
    return {
      nome_empresa: {
        required
      },
      subdominio: {
        required,
        notPoint: (value) => value.indexOf('.') === -1,
        formato: helpers.withMessage('Link não pode começar ou terminar com traço', helpers.regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)),
        has: helpers.withMessage('Subdomínio já cadastrado no sistema', helpers.withAsync(this.subdominioHas))
      },
      modelo: {
        required
      },
      telefone: {
        required,
        minLength: minLength(15)
      },
      cep: {
        required,
        minLength: minLength(9)
      },
      rua: {
        required
      },
      numero: {
        required
      },
      bairro: {
        required
      },
      cidade: {
        required
      },
      uf: {
        required,
        minLength: minLength(2)
      }
    }
  },
  methods: {
    ...mapActions(['VerifySubdominioHas', 'getApiCep']),
    async next () {
      let valid = await this.v$.$validate()
      if(!valid) {
        this.verify = this.v$
        return
      }
      this.$emit('changeView', 'StepThree')
    },
    formatarTexto(texto) {
      // Remove acentos e caracteres especiais
      let textoFormatado = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    
      // Remove todos os caracteres que não são letras, números, espaços ou traços
      textoFormatado = textoFormatado.replace(/[^a-zA-Z0-9 -]/g, '')

      // Remove espaços do início e do fim e substitui os demais por traços
      textoFormatado = textoFormatado.trim().replace(/\s+/g, '-')

      // Evita traços repetidos ou no início
      textoFormatado = textoFormatado.replace(/-+/g, '-').replace(/^-/, '')
    
      // Converte para minúsculas (opcional)
      textoFormatado = textoFormatado.toLowerCase()
    
      return textoFormatado
    },
    getEndereco (cep) {
      if(cep.length === 9) {
        this.getApiCep(cep.replace('-', ''))
          .then(data => {
            this.$emit('updateProp', { key: 'cep', value: cep })
            this.$emit('updateProp', { key: 'rua', value: data.logradouro })
            this.$emit('updateProp', { key: 'bairro', value: data.bairro })
            this.$emit('updateProp', { key: 'cidade', value: data.localidade })
            this.$emit('updateProp', { key: 'uf', value: data.uf })
          })
      }
    },
    async subdominioHas (str) { return await this.VerifySubdominioHas(str).then(res => res) }
  }
}
</script>

<style scoped>
.StepTwo {
  width: 94%;
  border-radius: 8px;
  padding: 3%;
  background-color: #FFFFFF;
}

.cont {
  display: flex;
  justify-content: space-between;
  padding-top: 2%;
}

.cont-next {
  padding-top: 2%;
}

button {
  border: 0;
  margin-top: 3%;
  padding: 11px;
  border-radius: 5px;
  background-color: #0E1E2B;
  color: #FFFFFF;
  cursor: pointer;
  margin: 1%;
  font-size: 18px;
}
</style>
